import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { putPropose, postRfpOpened, postPublicRfpParticipate } from 'proposals/api/procurementApiClient'

export const useProposeRequestForProposal = (
  token: string
): UseMutationResult<void, unknown, ProposeRequestType, unknown> => {
  return useMutation({
    mutationFn: (data: ProposeRequestType) => putPropose(token, data)
  })
}

export const useRequestForProposalOpenedMutation = (): UseMutationResult<
  void,
  unknown,
  { rfpId: string; recipientId: string },
  unknown
> => {
  return useMutation({
    mutationFn: (data: { rfpId: string; recipientId: string }) => postRfpOpened(data.rfpId, data.recipientId)
  })
}

export const usePublicRequestForProposalParticipate = (): UseMutationResult<
  void,
  unknown,
  { uniqueToken: string; payload: PublicRequestForProposalParticipateType },
  unknown
> => {
  return useMutation({
    mutationFn: ({ uniqueToken, payload }) => postPublicRfpParticipate(uniqueToken, payload)
  })
}
